import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center"
}

import { ref, type PropType } from "vue";
import type { Tol2008TreeDto } from "@api/tol2008-tree-dto";
import Tol2008PickerList from "./Tol2008PickerList.vue";
import { getEntityTranslation } from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tol2008Picker',
  props: {
	modelValue: {
		type: [Object, null] as PropType<Tol2008TreeDto | null>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const isOpen = ref(false as boolean);
const showbtn = ref(null as null | HTMLElement);
const emit = __emit;
const selectTol2008 = (ev: Tol2008TreeDto) => {
	emit("update:modelValue", ev);
	isOpen.value = false;
};
const removeSelection = () => {
	emit("update:modelValue", null);
};

return (_ctx: any,_cache: any) => {
  const _component_HakoWindow = _resolveComponent("HakoWindow")!

  return (_openBlock(), _createElementBlock("div", null, [
    (props.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(props.modelValue.rootCode) + " " + _toDisplayString(props.modelValue.code) + " - " + _toDisplayString(_unref(getEntityTranslation)(props.modelValue.translations, "name")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close ms-2",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (removeSelection()))
          })
        ]))
      : _createCommentVNode("", true),
    (!props.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "showbtn",
          ref: showbtn
        }, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isOpen.value = true), ["prevent","stop"]))
          }, _toDisplayString(_ctx.$t("tol.openSelection")), 1)
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_HakoWindow, {
      modelValue: isOpen.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isOpen).value = $event)),
      title: "Tol2008",
      size: "l",
      positionUnderElement: showbtn.value
    }, {
      default: _withCtx(() => [
        _createVNode(Tol2008PickerList, {
          onPick: _cache[2] || (_cache[2] = ($event: any) => (selectTol2008($event)))
        })
      ]),
      _: 1
    }, 8, ["modelValue", "positionUnderElement"])
  ]))
}
}

})